module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./MyExChangeView.js"));
	}, "MyExChangeView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=MyExChangeView!./src/pages/PunchClock/Bean/MyExChange/MyExChangeView.js
// module id = 1791
// module chunks = 418